<template>
  <div id="filters-section">
    <v-select
      :value="selectedSector"
      :items="sectorOptions"
      label="Sector"
      @input="selectFilter($event, 'sector')"
    />

    <label class="custom-label">Revenue size</label>
    <v-range-slider
      @input="selectFilter($event, '_consolidatedFinRevenueRange')"
      :value="selectedRevenueRange"
      min="0"
      max="7"
      :thumb-size="24"
      thumb-label="always"
    >
      <template v-slot:thumb-label="props">
        {{ getRevenueLabel(props.value) }}
      </template>
    </v-range-slider>

    <label class="custom-label">Employees</label>
    <v-range-slider
      @input="selectFilter($event, '_consolidatedEmployeeRange')"
      :value="selectedEmployeeRange"
      min="0"
      max="8"
      :thumb-size="24"
      thumb-label="always"
    >
      <template v-slot:thumb-label="props">
        {{ getEmployeeLabel(props.value) }}
      </template>
    </v-range-slider>

    <v-select
      :value="selectedSdg"
      :items="sdgOptions"
      multiple
      item-value="code"
      label="Sustainable Development Goal"
      placeholder="Any SDG"
      class="custom-placeholder"
      @input="selectFilter($event, 'sdg')"
    />
    <v-text-field
      :value="selectedDisplayName"
      label="Name"
      placeholder="Any name"
      class="custom-placeholder"
      @input="selectFilter($event, 'displayName')"
    ></v-text-field>

    <center>
      <v-btn @click="clearAll" class="clear-btn" text small color="primary">Clear filters</v-btn>
    </center>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import options from '@/data/options'
import format from '@/helpers/format'

export default {
  name: 'filters',
  computed: {
    ...mapGetters({
      selectedSdg: 'companies/selectedSdg',
      sectorOptions: 'companies/sectorOptions',
      selectedSector: 'companies/selectedSector',
      selectedRevenueRange: 'companies/selectedRevenueRange',
      selectedEmployeeRange: 'companies/selectedEmployeeRange',
      selectedDisplayName: 'companies/selectedDisplayName',
      selectedOtherDevTags: 'companies/selectedOtherDevTags',
    }),
    sdgOptions() {
      return options.sdgOptions
    },
    revenueOptions() {
      return options.revenueOptions
    },
    employeeOptions() {
      return options.employeeOptions
    },
  },

  methods: {
    ...mapActions({
      setFilter: 'companies/setFilter',
      resetZoom: 'map/resetZoom',
    }),
    selectFilter(value, key) {
      this.setFilter({ key, value })
    },
    clearAll() {
      this.setFilter({
        key: 'baseCountry',
        value: '',
      })
      this.setFilter({
        key: 'sector',
        value: '',
      })
      this.setFilter({
        key: 'displayName',
        value: '',
      })
      this.setFilter({
        key: 'sdg',
        value: [],
      })
      this.setFilter({
        key: '_consolidatedFinRevenueRange',
        value: [0, 7],
      })
      this.setFilter({
        key: '_consolidatedEmployeeRange',
        value: [0, 8],
      })
      this.resetZoom()
    },
    getRevenueLabel(value) {
      return format.getRevenueLabel(value)
    },
    getEmployeeLabel(value) {
      return format.getEmployeeLabel(value)
    },
  },
}
</script>

<style lang="scss" scoped>
#filters-section {
  max-width: 500px;
  margin: 0 auto 50px;
}
.custom-label {
  display: inline-block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.custom-placeholder:not(.v-input--is-dirty) ::v-deep ::placeholder {
  color: #000 !important;
}
.clear-btn {
  font-size: 10px;
}
#filters-section ::v-deep .v-slider__thumb-label {
  background-color: transparent !important;
  color: #000;
  transform: translateY(20%) translateY(25px) translateX(-12px) rotate(45deg) !important;
}
</style>
